import React, { useEffect, useState, useMemo } from "react";
import Chart from "../../Chart";
import * as FeatherIcon from "react-feather";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getUrlDetailsObj,
  getUserStatsObject,
  getVendorCompanyId,
  recordActivity,
  smartDecimalNumberFormatter,
} from "../../../services/commonService";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompFinancialRequest } from "../../../store/features/actions/companyFinancialsActions";
import BarGraphSkeleton from "../skeletons/barGraphSkeleton/barGraphSkeleton";
import { useUser } from "../../../context/UserContext";
import { getSandPCompanyDetails } from "../../../services/accIqService";

// +++++++++++++++++++++++++++++++++
const MNEMONIC_MAP = {
  IQ_TOTAL_REV: "financials",
  IQ_GP: "gross_profit",
  IQ_EBITDA: "ebitda",
  IQ_NI: "net_income",
};

const transformFinancialApiData = (data = []) => {
  const grouped = {
    financials: [],
    gross_profit: [],
    ebitda: [],
    net_income: [],
  };

  if (data?.length > 0) {
    data.forEach((item) => {
      const key = MNEMONIC_MAP[item.Mnemonic];

      if (!key) return;

      grouped[key].push({
        category: Number(item.year),
        value:
          item.Value === "Data Unavailable" || item.Value === null
            ? "Data Unavailable"
            : Number(item.Value),
        // value: item.Value !== null ? Number(item.Value) : null,
      });
    });

    return grouped;
  } else {
    return {};
  }
};
// +++++++++++++++++++++++++++++++++

const formatFinancialData = (data) => {
  if (!data) return [];
  const sortedData = data.sort(
    (a, b) => Number(a.category) - Number(b.category)
  );
  return sortedData.map((item) => ({
    ...item,
    value:
      item.value === "Data Unavailable"
        ? "Data Unavailable"
        : item.value == null
        ? null
        : smartDecimalNumberFormatter(item.value),
    // value: item.value == null ? null : smartDecimalNumberFormatter(item.value),
  }));
};

export default function KeyFinancials({
  handleTabChange = () => {},
  competitorInfo,
  setKeyFinancialsDataAvailable,
}) {
  const { user } = useUser();
  const dispatch = useDispatch();
  const { competitorName, clientName } = useParams();
  const [graph, setGraph] = useState("revenue");
  const navigate = useNavigate();
  const currentUrl = useLocation().pathname;
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const { financialsData, loading } = useSelector(
    (state) => state.companyFinancialsReducer
  );

  const transformedFinancials = useMemo(() => {
    if (!financialsData) {
      console.log("No financial data available");
    }
    return transformFinancialApiData(financialsData);
  }, [financialsData]);

  const vendorCompanyId = getVendorCompanyId(competitorInfo);

  // const financialsData = {
  //   data: {
  //     ticker: "MMM:NYSE",
  //     name: "3M Company",
  //     ebitda: [
  //       {
  //         category: 2024,
  //         value: 5361.0,
  //       },
  //       {
  //         category: 2023,
  //         value: 5710.0,
  //       },
  //       {
  //         category: 2022,
  //         value: 4703.0,
  //       },
  //       {
  //         category: 2021,
  //         value: 9669.0,
  //       },
  //       {
  //         category: 2020,
  //         value: 9067.0,
  //       },
  //     ],
  //     gross_profit: [
  //       {
  //         category: 2024,
  //         value: 10158.0,
  //       },
  //       {
  //         category: 2023,
  //         value: 9716.0,
  //       },
  //       {
  //         category: 2022,
  //         value: 10308.0,
  //       },
  //       {
  //         category: 2021,
  //         value: 16560.0,
  //       },
  //       {
  //         category: 2020,
  //         value: 15685.0,
  //       },
  //     ],
  //     net_income: [
  //       {
  //         category: 2024,
  //         value: 4173.0,
  //       },
  //       {
  //         category: 2023,
  //         value: -6995.0,
  //       },
  //       {
  //         category: 2022,
  //         value: 5777.0,
  //       },
  //       {
  //         category: 2021,
  //         value: 5921.0,
  //       },
  //       {
  //         category: 2020,
  //         value: 5449.0,
  //       },
  //     ],
  //     financials: [
  //       {
  //         category: 2024,
  //         value: 24575.0,
  //       },
  //       {
  //         category: 2023,
  //         value: 24610.0,
  //       },
  //       {
  //         category: 2022,
  //         value: 26161.0,
  //       },
  //       {
  //         category: 2021,
  //         value: 35355.0,
  //       },
  //       {
  //         category: 2020,
  //         value: 32184.0,
  //       },
  //     ],
  //   },
  // };
  // const { loading } = useSelector((state) => state.companyFinancialsReducer);

  // ++++++++++++++++++++++++++++++++++++++

  useEffect(() => {
    const getCompanyDetails = async () => {
      const compDetailsResponse = await getSandPCompanyDetails(vendorCompanyId);

      let payload = {
        competitorName: competitorName,
        identifier: compDetailsResponse?.ticker ?? "",
        vendor_company_id: vendorCompanyId,
      };

      if (competitorName) {
        dispatch(fetchCompFinancialRequest(payload));
      }
    };
    if (vendorCompanyId) getCompanyDetails();
  }, [competitorName]);
  // ++++++++++++++++++++++++++++++++++++++

  // const financials = useMemo(
  //   () => formatFinancialData(financialsData?.data?.financials),
  //   [loading]
  // );

  const financials = useMemo(
    () => formatFinancialData(transformedFinancials?.financials),
    [transformedFinancials]
  );

  // const grossProfit = useMemo(
  //   () => formatFinancialData(financialsData?.data?.gross_profit),
  //   [loading]
  // );

  const grossProfit = useMemo(
    () => formatFinancialData(transformedFinancials?.gross_profit),
    [transformedFinancials]
  );

  // const ebitDa = useMemo(
  //   () => formatFinancialData(financialsData?.data?.ebitda),
  //   [loading]
  // );

  const ebitDa = useMemo(
    () => formatFinancialData(transformedFinancials?.ebitda),
    [transformedFinancials]
  );

  // const netIncome = useMemo(
  //   () => formatFinancialData(financialsData?.data?.net_income),
  //   [loading]
  // );

  const netIncome = useMemo(
    () => formatFinancialData(transformedFinancials?.net_income),
    [transformedFinancials]
  );

  const lastYerFinValue = useMemo(
    () => financialsData?.last_year_financial?.value,
    [loading]
  );
  const finGrowth = useMemo(() => financialsData?.data?.growth, [loading]);

  const isRevenuesNan = useMemo(
    () => financials.every((item) => isNaN(Number(item.value))),
    [financials]
  );
  const isGrossProfitsNan = useMemo(
    () => grossProfit.every((item) => isNaN(Number(item.value))),
    [grossProfit]
  );
  const isEbitDasNan = useMemo(
    () => ebitDa.every((item) => isNaN(Number(item.value))),
    [ebitDa]
  );
  const isNetIncomesNan = useMemo(
    () => netIncome.every((item) => isNaN(Number(item.value))),
    [netIncome]
  );

  const isAllDataUnavailable = useMemo(() => {
    const allValues = [
      ...(financials || []),
      ...(grossProfit || []),
      ...(ebitDa || []),
      ...(netIncome || []),
    ];

    if (!allValues.length) return true;

    return allValues.every((item) => item.value === "Data Unavailable");
  }, [financials, grossProfit, ebitDa, netIncome]);

  useEffect(() => {
    if (!user?.id || !graph || !competitorName) {
      return;
    }
    const graph_tab = {
      revenue: "Revenue",
      gross_profit: "Gross Profit",
      ebitda: "EBITDA",
      net_income: "Net Income",
    }[graph];

    const userStat = getUserStatsObject(
      "Overview",
      "page_load",
      `Page Source: ${competitorName}, Key Financials Graph Tab: ${graph_tab}`,
      currentUrl
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);
  }, [graph, competitorName, user?.id]);

  const handleGraphChange = (graphName) => {
    setGraph(graphName);
  };

  const handleViewMoreFinanceLink = (e) => {
    e.preventDefault();
    const userStat = getUserStatsObject(
      "Overview",
      "View More Click",
      `Page Source: ${competitorName}, Key Financials`,
      currentUrl
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);

    // navigate(
    //   `/account_details/${accountId}/${encodeURIComponent(
    //     competitorName
    //   )}/${encodeURIComponent(clientName)}/?tab=more&subTab=financial`
    // );
  };

  // const renderChart = (data, isDataNan) => {
  //   if (data.length > 0 && !isDataNan) {
  //     return (
  //       <Chart
  //         financials_data={data?.map((item) => ({
  //           ...item,
  //           value: Math.round(item?.value),
  //         }))}
  //         active_chart={graph}
  //       />
  //     );
  //   }
  //   return null;
  // };
  const renderChart = (data, isDataNan) => {
  //Check for NaN values in the data  
  const cleanData = data.filter(
    (item) =>
      item.value !== null &&
      item.value !== "Data Unavailable" &&
      !isNaN(Number(item.value))
  );

  if (cleanData.length > 0 && !isDataNan) {
    return (
      <Chart
        financials_data={cleanData.map((item) => ({
          ...item,
          value: Math.round(Number(item.value)), // ensure number
        }))}
        active_chart={graph}
      />
    );
  }

  return null;
};

  // if ((!loading && !financialsData?.data) || !vendorCompanyId) {
  // if ((!loading && !financialsData?.length) || !vendorCompanyId) {
  if (
    (!loading && (!financialsData?.length || isAllDataUnavailable)) ||
    !vendorCompanyId
  ) {
    setKeyFinancialsDataAvailable(false);
    return null;
  }

  return (
    <>
      <div className="generic-take-space-child mb-2">
        <div className="custom_card_block mt-2 min_height_425">
          {vendorCompanyId && loading ? (
            <BarGraphSkeleton />
          ) : (
            <div className="key_finance_wrapper">
              <div className="head_top">
                <h5 className="main_head">
                  Key Financials (Last 5 Years $ Mn)
                </h5>
                <Link
                  // onClick={handleViewMoreFinanceLink}
                  onClick={() => {
                    handleTabChange("financials", true);
                  }}
                  className="custom_view_all"
                >
                  View All
                </Link>
              </div>

              <div className="graph_section">
                <div className="bn_value d-none">
                  {lastYerFinValue && (
                    <p className="bn_value_text">
                      $ {lastYerFinValue}
                      {finGrowth != "" &&
                        finGrowth != null &&
                        !isNaN(finGrowth) &&
                        isFinite(finGrowth) && (
                          <>
                            <span
                              className={
                                finGrowth > 0
                                  ? "arrow_value_green"
                                  : "arrow_value_red"
                              }
                            >
                              {finGrowth > 0 ? (
                                <FeatherIcon.Plus className="fa" />
                              ) : (
                                <FeatherIcon.Minus className="fa" />
                              )}
                            </span>
                            <span
                              className={
                                finGrowth > 0 ? "value_green" : "value_red"
                              }
                            >
                              {Math.abs(finGrowth)} %
                            </span>
                          </>
                        )}
                    </p>
                  )}
                </div>

                <div className="key_graph_tab">
                  {!isRevenuesNan && (
                    <span
                      onClick={() => handleGraphChange("revenue")}
                      className={`key_graph_btn ${
                        graph === "revenue" ? "active_tab_kf" : ""
                      }`}
                    >
                      Revenue
                    </span>
                  )}
                  {grossProfit?.length > 0 && !isGrossProfitsNan && (
                    <span
                      onClick={() => handleGraphChange("gross_profit")}
                      className={`key_graph_btn ${
                        graph === "gross_profit" ? "active_tab_kf" : ""
                      }`}
                    >
                      Gross Profit
                    </span>
                  )}
                  {ebitDa?.length > 0 && !isEbitDasNan && (
                    <span
                      onClick={() => handleGraphChange("ebitda")}
                      className={`key_graph_btn ${
                        graph === "ebitda" ? "active_tab_kf" : ""
                      }`}
                    >
                      EBITDA
                    </span>
                  )}
                  {netIncome?.length > 0 && !isNetIncomesNan && (
                    <span
                      onClick={() => handleGraphChange("net_income")}
                      className={`key_graph_btn ${
                        graph === "net_income" ? "active_tab_kf" : ""
                      }`}
                    >
                      Net Income
                    </span>
                  )}
                </div>

                {graph === "revenue" && renderChart(financials, isRevenuesNan)}
                {graph === "gross_profit" &&
                  renderChart(grossProfit, isGrossProfitsNan)}
                {graph === "ebitda" && renderChart(ebitDa, isEbitDasNan)}
                {graph === "net_income" &&
                  renderChart(netIncome, isNetIncomesNan)}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
